"use client"

import React from "react"
import { FloatingNav } from "@/components/ui/floating-navbar"
import { Home, BookOpen, LogIn } from "lucide-react"
import Link from "next/link"
import { cn } from "@/lib/utils"

export function PersistentNavbar() {
  const navItems = [
    {
      name: "首页",
      link: "/",
      icon: <Home className="h-4 w-4 text-neutral-500 dark:text-white" />,
    },
    {
      name: "教程",
      link: "/tutorial",
      icon: <BookOpen className="h-4 w-4 text-neutral-500 dark:text-white" />,
    },
    {
      name: "登录",
      link: "/sign-in",
      icon: <LogIn className="h-4 w-4 text-neutral-500 dark:text-white" />,
      isButton: true,
    },
  ]

  const renderCustomNav = () => {
    return (
      <>
        {navItems.map((navItem, idx) => (
          <Link
            key={`link=${idx}`}
            href={navItem.link}
            className={cn(
              "relative items-center flex space-x-1",
              navItem.isButton 
                ? "border text-sm font-medium relative border-neutral-200 dark:border-white/[0.2] text-black dark:text-white px-4 py-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors" 
                : "dark:text-neutral-50 text-neutral-600 dark:hover:text-neutral-300 hover:text-neutral-500"
            )}
          >
            <span className={navItem.isButton ? "" : "block sm:hidden"}>{navItem.icon}</span>
            <span className={navItem.isButton ? "text-sm ml-1" : "hidden sm:block text-sm"}>
              {navItem.name}
            </span>
            {navItem.isButton && (
              <span className="absolute inset-x-0 w-1/2 mx-auto -bottom-px bg-gradient-to-r from-transparent via-blue-500 to-transparent h-px" />
            )}
          </Link>
        ))}
      </>
    )
  }

  return (
    <div className="relative w-full">
      <FloatingNav 
        navItems={[]} 
        alwaysVisible={true}
        className="pr-2 pl-8 py-2"
      >
        {renderCustomNav()}
      </FloatingNav>
    </div>
  )
} 